<!--  -->
<template>
    <div class=''>

        <el-row type="flex" class="row-bg">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>社会责任</span>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="dialogVisible = true">
                            编辑</el-button>
                    </div>

                    <div class='content' v-html="csr">


                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-dialog title="编辑企业社会责任" :visible.sync="dialogVisible" width="1070px">

            <editor api-key="haztyc1gdz9xbcxczo9mpis2ruh9dsjh3tupypkoj8b11zam" :init="editorConf" v-model="newCsr">
            </editor>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="uploadHtmlContent">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    //例如：import 《组件名称》 from '《组件路径》';
    var Editor = require("@tinymce/tinymce-vue").default;
    // import '../../assets/langs/zh_CN'
    export default {
        //import引入的组件需要注入到对象中才能使用
        components: {
            editor: Editor // <- Important part
        },
        data() {
            //这里存放数据
            return {
                dialogVisible: false,
                csr: "暂无内容，请编辑",
                newCsr: ""
            };
        },
        //监听属性 类似于data概念
        computed: {},
        //监控data中的数据变化
        watch: {},
        //方法集合
        methods: {
            uploadHtmlContent() {
                var that = this;
                this.$request.post({
                    url: "/api/admin/cover/csr_t",
                    params: { html: that.newCsr },
                    callback: {
                        success: function (data) {
                            that.dialogVisible = false;
                            that.csr = data.data;
                        },
                        err: function (err) {
                            console.log(err);
                        }
                    }
                });
            }
        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {

        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {
            var that = this;
            this.$request.get({
                url: "/api/pageData/page_csr",
                callback: {
                    success: function (data) {
                        that.csr = data.data;
                        that.newCsr = data.data;
                    },
                    err: function (err) {
                        console.log(err);
                    }
                }
            });

        },
        beforeCreate() { }, //生命周期 - 创建之前
        beforeMount() { }, //生命周期 - 挂载之前
        beforeUpdate() { }, //生命周期 - 更新之前
        updated() { }, //生命周期 - 更新之后
        beforeDestroy() { }, //生命周期 - 销毁之前
        destroyed() { }, //生命周期 - 销毁完成
        activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style  scoped>
</style>